import React from 'react'
import { CustomModal } from '../CustomModal/CustomModal'
import { ButtonWhite } from '../Buttons/ButtonWhite'
import { ButtonWhiteTwo } from '../Buttons/ButtonWhiteTwo'
import { t } from 'i18next'

export const FormCheckModal = ({ showModal, setShowModal, reason, cuestion, onClickContinue, actionText, onClickAction }) => {
    return (
        <CustomModal
            showModal={showModal}
            setShowModal={setShowModal}
            centered
            size='lg'
        >
            <div className='text-center ps-4 pe-4'>
                <p className='fw-bold'>{reason}</p>
                <p className='fw-bold'>{cuestion}</p>
            </div>
            <div className='text-center d-flex'>
                <ButtonWhite className='shadow-none' onClick={onClickContinue}>
                    {t('CONTINUE')}
                </ButtonWhite>
                <ButtonWhiteTwo onClick={onClickAction}>
                    {actionText}
                </ButtonWhiteTwo>
            </div>
        </CustomModal>

    )
}
